module.exports = __webpack_public_path__ + "img/head.e7be24f5.jpeg";